
import { useEffect, useState } from 'react'
import axios from 'axios'
//COMPONENTES PARTES

//INPORTAÇOES DE ICONES E IMAGENS
import IconChecked from '../../acets/img_icon/checked.svg'


import MenuPainelAdmin from '../partils/AdminMenuPainel'
import IconNoChecked from '../../acets/img_icon/nochecked.svg'
import IconEdit from '../../acets/img_icon/edit.svg'

import TenancyColor from '../midllers/TenancyColor'
import { useNavigate } from 'react-router-dom';
import AdminHeader from '../partils/AdminHeader'

export default function AdminCusto(){
    const TenancyColorUser = localStorage.getItem('localcolorusers')
    const navigate = useNavigate();
    //CONGIGURAÇÕES=============================
    const config={
        pageName:'Custos',
        mainstring:'descricao',
        url:'/api/custo/',
        url2:'',
        search:'/api/custo/search/',
        urlOptions1:'',
        params:'',
        messegerError:'ATENÇÃO - Preencha os campos para salvar os dados ;D',
    }
     //INICIANDO CICLO DE ESTADOS
     useEffect(()=>{
        rec();

        // eslint-disable-next-line react-hooks/exhaustive-deps
        },[])
    //STATES======================================
    //id_cliente	nome	placa	carro	endereco	telefone	email	status	observacao	codigo_acess	tenancyId
    //id_cliente: '',	nome: '',	placa: '',	carro: '',	endereco: '',	telefone: '',	email: '',	status: '',	observacao: '',	codigo_acess: '',	tenancyId: '',
    const initialValues={ // DEFININDO UMA CONST PARA O STATE INICIAL 
      id_custo : '',	descricao: '',	valor: '',	status: '',	tenancyId: '',createdAt:'',numerodemeses:''
    }
    const [openNew,setOpenNew]=useState(false)// ABRIR TELA DE CADASTRAR E EDITAR
    const [values, setValues]=useState(initialValues) // INICIANDO UM STATE
    const [data, setData] = useState([])
    //FUNÇÕES=====================================
    const tlocal = localStorage.getItem('keyItemNameg')
    const headers = {
        'Content-Type': 'application/json',
        'token':tlocal,
    };
    function rec() {//CARREGAR ESTADOS E ATUALIZAR CICLO DE COMPONENTES
        axios.get(config.url,{headers}).then(resp=>{
            const invalid = {ERRO: 'token invalido 3'};
            if (JSON.stringify(resp.data[0]) === JSON.stringify(invalid)) {
              navigate('/login');
              window.location.reload(true);
            }
            else{
              setData(resp.data);
            }
        })
        //console.log(data[0])
        
    }
    function onChange(ev) {//ALTERAR OS STATES DOS INPUTS
        const {name, value} = ev.target; //ESTRAIR O NAME E VALUE DO EV
        setValues({ ...values, [name]:value }); //SETANDO O VALUE EM NAME
    }
    function onSubmit(ev){//CADASTRAR NO BANCO DE DADOS, obs refatorado para tirar o if e else e usar o. ternario edit e cadastrar
        ev.preventDefault();
        if(values.descricao===''||values.valor===''){
            alert("Atencao, preencha todos os campos!")
             }else{
            axios[values.id_custo?'put':'post'](config.url,values,{headers}).then(()=>{
                setOpenNew(false)
                setValues(initialValues);
                rec();
            })
        }
    }
    const editar = function(id){//EDITA VER CARREGA OS DADOS DO ITEM A SER EDITADO
        setOpenNew(true)
        axios.get(config.url + id,{headers}).then(respp=>{
            setValues(respp.data[0])
            })
    }
    const exclui = function(id){//EXCLUI
        axios.delete(config.url + id,{headers}).then(()=>{
            rec();
            setOpenNew(false)
            setValues(initialValues)
        })
    }
    function onSubmitSearch(ev){//PESQUISA
        ev.preventDefault();
        axios.post(config.search, values,{headers}).then(respp=>{
            setData(respp.data)       
        })
       
    }
    const colormes = function (mes){
            const mesesano =['null','Jan','Fev','Mar','Abr','Mai','Jun','Jul','Ago','Set','Out','Nov','Dez']
            return(mesesano[parseInt(mes)])
    }
    const usernivel = localStorage.getItem('usernivel') 
    //console.log(data[0].ERRO==='token invalido 3')
    //COMPONENTES DE LOOP==============================
    const final = data.map(
        namesString =>
            <div className='w100 h4 column center'  key={namesString.id_custo }> 
                
                {//<div className='w5'>{namesString.status===1?<img src={IconChecked}/>:<img src={IconNoChecked}/>}</div>
                //<div className='w5 cell-tamanho10'>{namesString.id_custo }</div>
                }
                <div className='w95 row between linha pcb3'>          
                    <div className='w10 c4 cell-none cell-tamanho20 cell-texto-p'>{ new Date(namesString.createdAt).toLocaleDateString('pt-BR')}</div>
                    <div className={`cen pcb3 w8 fb fs06em cont-circ b${22 + parseInt(namesString.createdAt.slice(5,7))}`}>{colormes(namesString.createdAt.slice(5,7))}</div>
                    <div className='w15 fs09em cont-circ '>{namesString.status===1?<div className='b25 cen fs06em pcb3 fb cont-circ'>Pend</div>:<div className='b24 cen fb fs06em pcb3 cont-circ'>Pago</div>}</div> 
                    <div className='w40 fs09em fb'>{namesString.descricao}</div>
                    <div className='w15 cell-margin5 c4 cell-texto-p '>R$:{namesString.valor}</div>
                    <div className="w5  h4 row end pp">
                    {namesString.descricao!=="Mensalidade autometricas"&&
                        <b onClick={()=>editar(namesString.id_custo )}> <img src={IconEdit}></img> </b>
                    }                   
                    </div>
                </div>
                
            </div>
    )

      //id_cliente	nome	placa	carro	endereco	telefone	email	status	observacao	codigo_acess	tenancyId
    return(
        <>
        {openNew&&           
            <div className='w100 h100 posifixedinicio column center z17' >
                <div className='w100 h100 posifixedinicio fundo-opaco z5' onClick={()=>(setOpenNew(false) & setValues(initialValues))}>
                </div>
                <div className='h20 w35 b2 cont-circ3 sombra column center z10 cell-tamanho90'>
                    <div className='w90 h20'>
                        <div className='w100'>
                            {values.id_custo?<h5>Editar {config.pageName}</h5>:<h5>Cadastrar novo(a) {config.pageName} Fixos</h5>  }
                        </div>
                        <form onSubmit={onSubmit} autoComplete='off'>
                            <div className='ma5'>
                                <label className='c4 fs09em'>Campos obrigatórios <span className='c9'>*</span> </label>
                            </div>
                            <div>
                                <label>Descricao <span className='c9'>*</span></label>
                                <input type="text"  name="descricao"  onChange={onChange} value={values.descricao} autoComplete='off'></input>
                            </div>
                            <div>
                                <label>valor <span className='c9'>*</span></label>
                                <input type="text"  name="valor"  onChange={onChange} value={values.valor}>
                                </input>
                            </div>
                            {!values.id_custo &&<>
                                <div>
                                    <label>Repetir o custo automaticamente quantos meses? Ex: 6</label>
                                    <input 
                                        type="number" 
                                        name="numerodemeses" 
                                        max={24}  // Alterado de 12 para 24
                                        min={1}   // Adicionado para evitar valores negativos ou zero
                                        onChange={onChange} 
                                        value={values.numerodemeses}
                                    /> {/* Removida a tag </input> (autofechamento) */}
                                </div>
                            </>}
                            {values.id_custo &&<>
                            <div>
                                <label>Mes competencia inserido: {new Date(values.createdAt).toLocaleDateString('pt-BR')}</label>
                                <input type="date"  name="createdAt"  onChange={onChange} value={values.createdAt}>
                                </input>
                            </div>
                            </>}
                            <div>
                                <label>status <span className='c9'>*</span></label>
                                <select type="text"  name="status"  onChange={onChange} value={values.status}>
                                    <option value={1}>Pendente Pagamento</option>
                                    <option value={2}>Pago</option>
                                </select>
                            </div>
                            <div className='cell-margin5'>
                                <button type="submit" className='w100'>{values.id_custo ? 'Atualizar' : 'Cadastrar'}</button>
                            </div>
                        </form>
                        <div className='w100 row between'>
                            {values.id_custo?
                            <button className='w25 btn04 cell-tamanho-metade' onClick={()=>exclui(values.id_custo)}>Excluir</button>:
                            <label className='w40'>Sem mais opções</label>}
                            <button onClick={()=>(setOpenNew(false) & setValues(initialValues))} className="w40 ma10b0 btn05">Cancelar</button>
                        </div>
                        
                    </div>
                </div>
            </div>
        }
        
        <section className='h100 row between b31'>
            
            <MenuPainelAdmin/>
            <div className="h100 w80 cell-tamanho row center celular">
                    
                <div className="w100 row between cell-tamanho celular">
                    <div className="h100 w100 cont-circ3  column cell-tamanho cell-paddingcb10">
                        <h5 className='fs2em fb w90'>{config.pageName} Fixos</h5>
                        <form className=' w90 row center' onSubmit={onSubmitSearch} autoComplete='off'>
                            <div className='btn10 b37' onClick={()=>(setOpenNew(true))&setValues(initialValues)} style={{backgroundColor:TenancyColorUser}}>Add</div>
                            <div className='w60'>
                                <input type="text" style={{border:0,backgroundColor:'#fff'}} name="descricao" onChange={onChange} placeholder=' Search'/>
                            </div>
                            <div className='w20 b37' style={{backgroundColor:TenancyColorUser}}>
                                <input type="submit" value="Pesquisar" style={{backgroundColor: TenancyColorUser}} className='cell-text-smile08'/>
                            </div>
                        </form>
                        
                        {/*
                        <div className='w90 h20 column '>
                        usernivel>=20&&<>
                            <label className='w100 ma5'>Custo da plataforma de gestão Auto Metricas para a sua empresa:</label>
                            <div className='w100 h20 borda1 b2 ma10b0 row around'>
                                <div className="h10 w15 cont-circ3  column start cell-tamanho-metade30 cell-margin5 cell-none">
                                    <label className=" ma10b0 c1 fb cen">Primeiro Mês</label>
                                    {/*<label className="fs06em cen c1">Fiados</label>
                                    <div className="row">
                                    <label className="fs06em">R$:</label>
                                    <label className=" fb h5 column center c4">43,90</label>
                                    </div>
                                </div>
                                <div className="h10 w15 cont-circ3  column start cell-tamanho-metade30 cell-margin5">
                                    <label className=" ma10b0 c1 fb cen">3 primeiros Meses</label>
                                    {/*<label className="fs06em cen c1">Fiados</label>
                                    <div className="row">
                                    <label className="fs06em cen">R$:</label>
                                    <label className=" fb h5 column center c4 cen">140 = 46,70 Mês</label>
                                    </div>
                                </div>
                                <div className="h10 w15 cont-circ3  column start cell-tamanho-metade30 cell-margin5">
                                    <label className=" ma10b0 c1 fb cen">Pagamento PIX</label>
                                    {/*<label className="fs06em cen c1">Fiados</label>}
                                    <div className="row">
                                    <label className="fs06em cen w100">Pagar 3 Meses</label>
                                    <label className="fb h5 column center c4 w100 pp">
                                        <a 
                                            href='https://nubank.com.br/pagar/1a2kg1/sKvJ8eq1Xu' 
                                            target="_blank" 
                                            rel="noopener noreferrer"
                                        >
                                            Pagar
                                        </a>
                                    </label>
                                    </div>
                                </div>
                                <div className="h10 w15 cont-circ3  column start cell-tamanho-metade30 cell-margin5">
                                    <label className=" ma10b0 c1 fb cen">Ver planos</label>
                                    {/*<label className="fs06em cen c1">Fiados</label>*
                                    <div className="row">
                                    <label className="fs06em"></label>
                                    <label className=" fb h5 column center c4">Mais info</label>
                                    </div>
                                </div>
                        
                            </div>
                            <label className='w100  fs08em '>Atenção! A mensalidade do sistema custa 189,00 Reais por mês, para clientes que faturam abaixo de 10Mil reais mensais a mensalidade tem desconto para R$:60 Reais mensais após o periodo de promoção de 3 meses. Após pagamento a baixa das mensalidades são realizadas em até 24h.</label>
                            </>
                            </div>
                            */}
                            <label className='w90 fs08em ma10b0'>Cadastre todos os custos da sua empresa como Aluguel, energia, Agua, Salarios, Despesas, Boletos</label>
                            
                           

                        <div className='w90 h10 column b2 borda1 ma20b0'>
                            <div className='w100 b36 column center'>
                                <div className='w95 c3 pcb10 row between'>
                                    
                                    <label className='c2 w10 fs09em cell-none'>Competencia</label>
                                    <label className='c2 w10 fs09em cell-tamanho15'>Mês</label>
                                    <label className='c2 w10 fs09em cell-tamanho15'>Status</label>
                                    <label className='c2 w40 fs09em'>Descrição</label>
                                    <label className='c2 w15 fs09em cell-none'>Valor</label>
                                    
                                    <label className='c2 w5 fs09em cell-tamanho15'>Editar</label>
                                </div>
                                   
                            </div>
                            {final}
                        </div>     
                    </div>
                </div>
            </div>
           
        </section>
      </>
    )
}





// x s